import React, { FC } from 'react'

import { IconButton, DialogActions, DialogTitle, Dialog, DialogContent } from '@mui/material'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg'
import { useIsMobile } from '../../utils/useIsMobile'
import { CustomButton } from '../CustomButton'

import { ModalProps } from './types'

export const CustomModalComponent: FC<ModalProps> = ({
  open,
  onClose,
  onSubmit,
  children,
  modalBodyStyles,
  showBodyDividers = true,
  dialogTitleStyles,
  dialogActionsStyles,
  dialogTransitionProps,
  showSubmitButton = true,
  showCancelButton = true,
  submitButtonText,
  cancelButtonText,
  submitButtonProps = {},
  hideTopCloseButton = false,
  disableSubmitButton = false,
  actions,
  title,
  maxWidth = 'sm',
  fullWidth = false,
}) => {
  const { t } = useTranslation()

  const isMobile = useIsMobile('sm')

  const showActions = showCancelButton || showSubmitButton

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      TransitionProps={dialogTransitionProps}
    >
      <DialogTitle sx={dialogTitleStyles}>{title}</DialogTitle>
      {!hideTopCloseButton && (
        <IconButton className="close-button" aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent dividers={showBodyDividers} sx={modalBodyStyles}>
        {children}
      </DialogContent>

      {showActions && (
        <DialogActions sx={dialogActionsStyles}>
          {showCancelButton && (
            <CustomButton color="secondary" onClick={onClose}>
              {cancelButtonText || t('cancel')}
            </CustomButton>
          )}
          {showSubmitButton && (
            <CustomButton
              disabled={disableSubmitButton}
              color="primary"
              onClick={onSubmit && onSubmit}
              {...submitButtonProps}
            >
              {submitButtonText || t('confirm')}
            </CustomButton>
          )}
          {actions}
        </DialogActions>
      )}
    </Dialog>
  )
}

export const CustomModal = React.memo(CustomModalComponent, isEqual)
